import React from 'react';
import { SearchTermContainer } from '../../styled.bottomSheetSelector';
import { IHighlightTextProps } from '../../../@types/bottomSheet';

export function HighlightText ({ text, searchWords, isChecked }: IHighlightTextProps) {
  if (!searchWords.length) {
    return <>{text}</>;
  }

  const regex = new RegExp(`(${searchWords.join('|')})`, 'gi');
  const textParts = text.split(regex);

  return (
    <>
      {textParts.map((textPart, index) => {
        const isMatch = searchWords.includes(textPart.toLowerCase());
        const shouldHighlight = isMatch && !isChecked;

        if (shouldHighlight) {
          return <SearchTermContainer key={`${textPart}-${index}`}>{textPart}</SearchTermContainer>;
        }

        return textPart;
      })}
    </>
  );
}
